<template>
  <div class="map-container">
    <HereMap v-if="!isEmpty"
    />
    <div v-else>
      <span class="no-location-text">Location Not Available</span>
    </div>
  </div>
</template>
<script>

import HereMap from '@common/components/map/HereMap';

export default {
  components: {
    HereMap,
  },
  data() {
    const mapData = this.$session.get('mapData');
    const paths = mapData.locations.map((path) => {
      const position = {
        lat: path.loc[0],
        lng: path.loc[1],
        createdAt: path.createdAt,
      };
      return position;
    });
    const drops = mapData.trip
      ? mapData.trip.drops.map((drop, index) => {
        const position = { lat: drop.loc[0], lng: drop.loc[1] };
        return {
          index: paths.length + index,
          position,
          lat: drop.loc[0],
          lng: drop.loc[1],
          type: 'drop',
          name: drop.name,
        };
      })
      : null;
    const location = paths.length > 0 ? paths[0] : null;
    return {
      isEmpty: location === null || drops === null,
    };
  },
};
</script>
<style lang="scss">
.no-location-text {
  color: #6D8EB4;
  display: inline-block;
  margin-left: 20px;
  font-size: 18px;
  font-weight: 300;
}
.map-container {
  position: absolute;
    width: 100%;
    height: 100%;
}
</style>
